import Grid from '@mui/material/Grid'
import { TextInput, SimpleForm, SelectInput, ImageInput } from 'react-admin'

import { validateRequired } from '../../utils/validate'
import GridContainer from '../../components/GridContainer'
import CustomImageField from '../../components/CustomImageField'
import RichTextInput from '../../components/RichTextInput'
import { VOICE_OPTIONS } from '../../components/constants'

const genderChoices = [
  { id: 'male', name: 'Male' },
  { id: 'female', name: 'Female' },
  { id: 'other', name: 'Other' },
]

const VoiceActorForm = props => {
  return (
    <SimpleForm {...props} redirect="list">
      <GridContainer>
        <Grid item xs={12}>
          <TextInput
            source="name"
            fullWidth
            variant="standard"
            validate={validateRequired('Name')}
          />
        </Grid>
        <Grid item xs={12}>
          <RichTextInput
            source="description"
            resettable
            rows={5}
            fullWidth
            variant="standard"
            multiline
          />
        </Grid>
        <Grid item xs={6}>
          <SelectInput
            source="gender"
            choices={genderChoices}
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={6}>
          <SelectInput
            source="relatedAiVoice"
            label="Related AI Voice"
            choices={VOICE_OPTIONS.map(option => ({
              id: option,
              name: option,
            }))}
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={12}>
          <ImageInput
            source="avatar"
            label="Avatar"
            accept="image/*"
            variant="standard"
            multiple={false}>
            <CustomImageField source="src" title="Avatar" />
          </ImageInput>
        </Grid>
        <Grid item xs={12}>
          <TextInput
            source="note"
            label="Notes"
            resettable
            rows={3}
            fullWidth
            variant="standard"
            multiline
          />
        </Grid>
      </GridContainer>
    </SimpleForm>
  )
}

export default VoiceActorForm
